export {parseSelector} from './lib/index.js'
